import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const testimonials = [{
  quote: 'Llevaba 3 años consumiendo contenido de manifestación sin resultados reales. En la semana 2 del Protocolo 24H recibí una oferta laboral que no había buscado.',
  name: 'Valentina R.',
  age: 34,
  city: 'Buenos Aires'
}, {
  quote: 'El Tomo 3 sobre el desapego fue lo que me faltaba. Siempre supe visualizar. Nunca supe soltar. Ese era mi bloqueo y el sistema lo identifica y lo resuelve.',
  name: 'Sebastián M.',
  age: 41,
  city: 'Ciudad de México'
}, {
  quote: 'Los guiones de auto-hipnosis del Bono 2 son lo más poderoso del sistema. Me grabé con mi propia voz y los escucho antes de dormir. Algo en eso funciona diferente a cualquier audio que había comprado antes.',
  name: 'Carolina L.',
  age: 28,
  city: 'Bogotá'
}, {
  quote: 'El Plan de 21 Días fue la clave para mí. Siempre empezaba y dejaba. Con el plan sabía exactamente qué hacer cada día. Llegué al día 21 por primera vez en mi vida.',
  name: 'Ana P. G.',
  age: 45,
  city: 'Lima'
}];
export function TestimonialsSection() {
  return <SectionWrapper bgColor="bg-brand-testimonial" data-id="element-225">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold mb-10" data-id="element-226">
        Lo que dicen quienes ya implementaron el sistema:
      </h2>

      <div className="space-y-6" data-id="element-227">
        {testimonials.map((t, i) => <div key={i} className="border-l-2 border-brand-gold/40 pl-6 md:pl-8 py-2" data-id="element-228">
            <p className="text-brand-ivory/85 font-body text-base md:text-lg italic leading-relaxed" data-id="element-229">
              "{t.quote}"
            </p>
            <p className="text-brand-gold font-body font-semibold text-sm mt-4" data-id="element-230">
              — {t.name}, {t.age} años · {t.city}
            </p>
          </div>)}
      </div>
    </SectionWrapper>;
}